import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '@/config/firebase';
import { compressImage, validateImageFile, deleteImage } from './productManagerImageService';
import { updateApp } from './appRegistryService';

export async function uploadAppScreenshot(appId: string, file: File): Promise<string> {
  const validation = validateImageFile(file);
  if (!validation.valid) throw new Error(validation.error);

  const compressed = await compressImage(file);
  const ext = file.name.split('.').pop() || 'png';
  const path = `app-assets/${appId}/${Date.now()}_screenshot.${ext}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, compressed);
  const url = await getDownloadURL(storageRef);
  await updateApp(appId, { screenshotUrl: url });
  return url;
}

export async function uploadAppIcon(appId: string, file: File): Promise<string> {
  const validation = validateImageFile(file);
  if (!validation.valid) throw new Error(validation.error);

  const compressed = await compressImage(file);
  const ext = file.name.split('.').pop() || 'png';
  const path = `app-assets/${appId}/${Date.now()}_icon.${ext}`;
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, compressed);
  const url = await getDownloadURL(storageRef);
  await updateApp(appId, { customIconUrl: url });
  return url;
}

export async function deleteAppAsset(
  appId: string,
  field: 'screenshotUrl' | 'customIconUrl',
  currentUrl: string
): Promise<void> {
  await deleteImage(currentUrl);
  await updateApp(appId, { [field]: null });
}
